// Training sources the app can connect, in display order (2026-10-11). Plain configuration — the
// single list Home and Profile render from. Adding a source later = one entry here + its row in
// TrainingConnectionsSection. `enabled` is the frontend switch; each source's own backend status
// still decides what the user sees (Garmin appears only for users the backend reports as eligible).
//
// logo: path to an OFFICIAL brand asset only (never a drawn / recreated mark). None is in the repo
// yet, so a neutral initial tile is shown (components/connections/ConnectionParts.jsx).
import { GARMIN_ENABLED } from './features';

export const TRAINING_SOURCES = [
  { id: 'garmin', name: 'Garmin', description: 'סנכרון פעילויות ריצה', badge: 'פיילוט', logo: null,
    enabled: GARMIN_ENABLED },
  // Strava removed (C2, 2026-10-21): Garmin through Stridee is the only training source.
];

// Is this source shown? `enabled`, or (legacy) the user is already connected to it.
export function sourceVisible(source, connected) {
  return Boolean(source && (source.enabled || (source.visibleWhenConnected && connected === true)));
}

// Profile anchor for "ניהול חיבורים" (Home -> Profile, scrolled to the connections section).
export const TRAINING_CONNECTIONS_ANCHOR = 'training-connections';
